import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import OrderUtils from 'utils/Order';
import RetailDeliveryFeeItemEN from 'components/SharedComponents/RetailDeliveryFeeItem/locales/RetailDeliveryFeeItem_en_US';
import RetailDeliveryFeeItemFR from 'components/SharedComponents/RetailDeliveryFeeItem/locales/RetailDeliveryFeeItem_fr_CA';

const { getRDF } = OrderUtils;
const { wrapHOC } = FrameworkUtils;
const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(RetailDeliveryFeeItemEN, RetailDeliveryFeeItemFR);

const mapStateToProps = (state, ownProps) => {
    const defaultText = getTextFromResource(getText, 'defaultText')(state);

    const feesAsArray = state.order?.orderDetails?.priceInfo?.fees;
    const priceInfo = ownProps.priceInfo;
    const isCheckout = ownProps.isCheckout;
    const isOrderConfirmation = ownProps.isOrderConfirmation;
    const orderDetails = state.order?.orderDetails;

    const feeAmount = getRDF({
        feesAsArray,
        priceInfo,
        orderDetails,
        isCheckout,
        isOrderConfirmation
    });

    let qty = feeAmount;

    if (isCheckout && !feeAmount) {
        qty = getTextFromResource(getText, 'qtyTbd')(state);
    }

    const hasShippingGroups = state.order?.orderDetails?.shippingGroups?.shippingGroupsEntries?.length;
    let visible = false;

    if (hasShippingGroups) {
        const shippingGroupAddress = state.order?.orderDetails?.shippingGroups?.shippingGroupsEntries[0]?.shippingGroup?.address || {};
        const { postalCode: shippingPostalCode = '', state: shippingState = '' } = shippingGroupAddress;

        visible = Boolean(shippingPostalCode !== '' && shippingState !== '' && feeAmount);
    }

    return {
        defaultText,
        qty,
        visible
    };
};

const withRetailDeliveryFeeItemProps = wrapHOC(connect(mapStateToProps));

export { withRetailDeliveryFeeItemProps };
